<template>
  <div class="page">
    <div class="box1">
      <div></div>
      <img src="../assets/gis/caso.png" alt="" />
    </div>

    <div class="box2">
      <div class="box3">
        <div class="from">
          <div class="input1">
            <label for="userName"></label>
            <p></p>
            <div>
              <input
                type="text"
                v-model="userName"
                placeholder="用户名/邮箱"
                id="userName"
              />
            </div>
          </div>
          <div class="input2">
            <label for="password"></label>
            <p></p>
            <div>
              <input
                type="password"
                v-model="password"
                :placeholder="
                  '请输入密码' + (showBtn ? '，注册新账号时不需要' : '')
                "
                id="password"
              />
            </div>
          </div>
          <div class="btns">
            <template v-if="showBtn">
              <el-button @click="registerAccount" type="primary"
                >注册新账号</el-button
              >
              <el-button @click="bindAccount" type="success"
                >绑定已有账号</el-button
              ></template
            >
            <template v-else>
              <el-button @click="login" type="primary">登 录</el-button>
              <el-button @click.stop="startWxLogin" type="success"
                >微信扫码登录</el-button
              >
            </template>
          </div>
          <p v-if="!showBtn">
            没有账号? 请点击 &nbsp;<a href="#" @click="signup">注册</a>;
            忘记密码请点击 &nbsp;<a href="#" @click="resetPassword">找回</a>
          </p>
        </div>
      </div>
    </div>
    <el-dialog
      title="微信扫码登录"
      :visible.sync="showQr"
      width="400px"
      :close-on-click-modal="false"
      :before-close="
        (done) => {
          done(false);
        }
      "
      :show-close="false"
      :show-cancel-button="false"
      :show-confirm-button="false"
    >
      <iframe
        :src="qrUrl"
        frameborder="0"
        style="width: 300px; height: 400px"
      ></iframe
    ></el-dialog>
  </div>
</template>
<script>
import { $user } from "@/services";
import { setToken } from "@/utils/auth";
export default {
  name: "Login",
  data() {
    return {
      userName: "",
      password: "",
      showQr: false,
      qrUrl: "",
      state: "",
      pollTimer: null,
      showBtn: false,
      unionId: "",
    };
  },
  mounted() {
    if (this.$route.query.unionId) {
      this.showBtn = true;
      this.unionId = this.$route.query.unionId;
    }
    window.addEventListener("message", this.handleMessage, false);
  },
  beforeDestroy() {
    window.removeEventListener("message", this.handleMessage, false);
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  },
  methods: {
    // [修复] 1. 将 handleMessage 标记为 async
    async handleMessage(event) {
      if (event.data.type === "wx_login_success") {
        let t = event.data.data;
        await this.handleLogin({
          token: t.token,
          name: t.info?.userName,
          userInfo: t.info,
        });
      }
    },
    startWxLogin() {
      this.qrUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wx9d45a1ae0e2dc40b&redirect_uri=https%3A%2F%2Fwww.kxwj.cn%2Fwx_login_callback.html&response_type=code&scope=snsapi_login&state=123456#wechat_redirect`;
      // this.showQr = true
      // this.qrUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wx9d45a1ae0e2dc40b&redirect_uri=https%3A%2F%2Fwww.kxwj.cn%2Ftest%2Flogin%2Fwx_login_callback.html&response_type=code&scope=snsapi_userinfo&state=123456#wechat_redirect`;
      window.open(this.qrUrl, "微信扫码登录", "width=600,height=600");
    },
    async bindAccount() {
      if (!this.userName || !this.password)
        return this.$message.warning("请输入用户名和密码");
      const res = await $user.wxBindUser({
        unionId: this.unionId,
        userName: this.userName,
        password: this.password,
      });
      if (res.success) {
        await this.handleLogin({
          token: res.data.token,
          name: this.userName,
          userInfo: res.data.userInfo,
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },

    async registerAccount() {
      if (!this.userName) return this.$message.warning("请输入用户名");
      const res = await $user.wxRegister({
        unionId: this.unionId,
        userName: this.userName,
      });
      if (res.success) {
        await this.handleLogin({
          token: res.data.token,
          name: this.userName,
          userInfo: res.data.userInfo,
        });
      } else {
        this.$message({
          message: res.msg,
          type: "error",
        });
      }
    },
    login() {
      if (this.userName && this.password) {
        this.$store
          .dispatch("Login", {
            userName: this.userName.trim(),
            password: this.password.trim(),
          })
          .then(() => {
            this.$message.success("登录成功");
            // 登录成功后直接拉取信息并跳转
            this.$store.dispatch("GetInfo").then(() => {
              this.$router.push(this.$route.query.redirect || "/map");
            });
          })
          .catch((err) => {
            this.$message.error(err.message || "登录失败，请重新输入");
          });
      }
    },
    async handleLogin({ token, name, userInfo }) {
      console.log(name);
      // 1. 通过工具类存储 Token
      setToken(token);

      // 2. 更新 Vuex 内存状态
      this.$store.commit("SET_TOKEN", token);
      this.$store.commit("SET_USER_INFO", userInfo);

      // 3. 拉取最新的权限和完整信息
      try {
        await this.$store.dispatch("GetInfo");
      } catch (error) {
        console.error("Error during GetInfo dispatch:", error);
      }

      // 4. 执行跳转
      if (this.$route.query?.redirect) {
        this.$router.push(this.$route.query.redirect);
      } else {
        this.$router.push("/map");
      }
    },
    signup() {
      this.$router.push("signType");
    },
    resetPassword() {
      this.$router.push("resetPassword");
    },
  },
};
</script>
<style lang="less" scoped>
@cyan: #00baff;

.page {
  background-image: url(../assets/bj-1.jpg);
  background-size: cover;
  background-position: left top;
  background-repeat: no-repeat;
  // background-color: #cdd1d3;
  // background-color: #158bb8;
  // background-color: #cdd1d325;

  .box1 {
    height: 10vh;
    position: relative;

    img {
      position: absolute;
      width: 30%;
      bottom: 0;
      left: calc(50% - 15%);
    }

    div {
      width: 100%;
      height: 100%;
    }
  }

  .box2 {
    height: 90vh;
    background-color: #cdd1d325;
    position: relative;

    .box3 {
      background-image: url(../assets/back.png);
      position: absolute;
      top: 0;
      width: 100%;
      height: 70vh;
      display: flex;
      justify-content: center;
      align-items: center;

      .from {
        width: 500px;
        padding: 20px 0;
        background-color: rgba(240, 248, 255, 0.479);
        box-shadow: 0px 2px 6px 0px rgba(181, 181, 181, 0.9);
        border-radius: 3px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;

        > p {
          text-align: center;
          color: #666;
          font-size: 16px;
          margin-top: 20px;
          width: 100%;
          // text-align: end;
          margin-right: 15px;
          margin-bottom: 20px;

          a {
            color: blue;
            font-size: 18px;
            // border: 1px solid rgba(136, 102, 187, 0.336);
            padding: 3px 6px;
          }
        }

        label {
          display: block;
          width: 25px;
          text-align: center;
          height: 25px;
        }

        .input1 {
          margin-top: 30px;
          margin-bottom: 10px;

          label {
            background-image: url("../assets/1.svg");
            background-size: 20px 20px;
            background-repeat: no-repeat;
            background-position: center center;
          }
        }

        .input2 label {
          background-image: url("../assets/2.svg");
          background-size: 20px 20px;
          background-repeat: no-repeat;
          background-position: center center;
        }

        .btns {
          margin-top: 15px;
          display: flex;
          align-items: center;
        }

        > div {
          display: flex;
          align-items: center;
          background-color: #cdd1d3;
          color: #666;
          border: 1px solid #bcbcbc;

          p {
            width: 1px;
            height: 80%;
            background-color: #464646;
          }

          div {
            height: 35px;
            width: 250px;
            border: 1px solid #ccc;
            border-radius: 2px;

            input {
              border: none;
              outline: 0;
              height: 100%;
              width: 100%;
              box-sizing: border-box;
              padding: 0px 5px;
              background-color: transparent;
            }
          }
        }
      }
    }
  }
}
</style>